export default __webpack_public_path__ + "static/media/english-to-portuguese-screenshot-01.ef517caa.png";